(function() {
  const root = document.querySelector('.bsel-cfg');
  if (!root) return;

  const animEls = root.querySelectorAll('.bsel-cfg-anim');
  if (animEls.length > 0 && typeof IntersectionObserver !== 'undefined') {
    const animIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('bsel-cfg-visible');
          animIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    animEls.forEach(function(el) { animIo.observe(el); });

    setTimeout(function() {
      animEls.forEach(function(el) {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.add('bsel-cfg-visible');
        }
      });
    }, 800);
  } else {
    animEls.forEach(function(el) { el.classList.add('bsel-cfg-visible'); });
  }

  const state = {
    bundle_heading: 'Choose a quantity',
    bundle_popular: 'MOST POPULAR',
    bundle_soldout: 'Sold Out',
    mm_title: 'Mix & Match, Save 10%',
    mm_desc: 'Build your own bundle with any of our products and save more!',
    popup_heading: 'Build Your Bundle',
    popup_desc: 'Select your 2nd product to create a custom bundle and save 10%!',
    bundle_border: '#F35D9C',
    bundle_selbg: '#2A1A24',
    bundle_popbg: '#F35D9C',
    bundle_price: '#FFFFFF',
    bundle_radius: 12,
    sub_heading: 'Choose an option',
    sub_onetime: 'One-time purchase',
    sub_recurring: 'Subscribe & Save',
    sub_border: 'rgba(255, 255, 255, 0.1)',
    sub_selborder: '#F35D9C',
    sub_selbg: '#2A1A24',
    sub_badgebg: '#F35D9C',
    sub_badgetext: '#FFFFFF',
    sub_radius: 12
  };

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return root.querySelectorAll(sel); }

  const textBindings = {
    bundle_heading: '#bselCfgBundleHeading',
    bundle_popular: '#bselCfgBundlePopular',
    mm_title: '#bselCfgMmTitle',
    mm_desc: '#bselCfgMmDesc',
    popup_heading: '#bselCfgPopupHeading',
    popup_desc: '#bselCfgPopupDesc',
    sub_heading: '#bselCfgSubHeading',
    sub_onetime: '#bselCfgSubOnetime',
    sub_recurring: '#bselCfgSubRecurring'
  };

  function render() {
    Object.keys(textBindings).forEach(function(key) {
      const el = $(textBindings[key]);
      if (el) el.textContent = state[key];
    });

    $$('[data-bsel-bundle] .bsel-cfg__pc-option').forEach(function(o) {
      o.style.borderRadius = state.bundle_radius + 'px';
      if (o.classList.contains('is-on')) {
        o.style.borderColor = state.bundle_border;
        o.style.background = state.bundle_selbg;
      } else {
        o.style.borderColor = '';
        o.style.background = '';
      }
    });

    $$('[data-bsel-popular] .bsel-cfg__pc-pop').forEach(function(p) {
      p.style.background = state.bundle_popbg;
    });

    $$('[data-bsel-price-of]').forEach(function(p) {
      p.style.color = state.bundle_price;
    });

    $$('[data-bsel-sub] .bsel-cfg__sub-option').forEach(function(o) {
      o.style.borderRadius = state.sub_radius + 'px';
      const radio = o.querySelector('.bsel-cfg__sub-radio');
      if (o.classList.contains('is-on')) {
        o.style.borderColor = state.sub_selborder;
        o.style.background = state.sub_selbg;
        if (radio) {
          radio.style.borderColor = state.sub_selborder;
          radio.style.setProperty('--bsel-cfg-radio-dot', state.sub_selborder);
        }
      } else {
        o.style.borderColor = state.sub_border;
        o.style.background = '';
        if (radio) {
          radio.style.borderColor = '';
          radio.style.removeProperty('--bsel-cfg-radio-dot');
        }
      }
    });

    const badge = $('#bselCfgSubBadge');
    if (badge) {
      badge.style.background = state.sub_badgebg;
      badge.style.color = state.sub_badgetext;
    }

    $$('[data-swatches]').forEach(function(group) {
      const key = group.dataset.swatches;
      const val = state[key];
      group.querySelectorAll('.bsel-cfg__sw').forEach(function(sw) {
        sw.classList.toggle('is-on', sw.dataset.color && sw.dataset.color.toLowerCase() === (val || '').toLowerCase());
      });
    });

    $$('[data-color-pip]').forEach(function(pip) {
      const key = pip.dataset.colorPip;
      pip.style.background = state[key];
    });

    $$('[data-color-input]').forEach(function(input) {
      const key = input.dataset.colorInput;
      if (document.activeElement !== input) input.value = (state[key] || '').toUpperCase();
    });
  }

  $$('[data-bsel-tab]').forEach(function(tab) {
    tab.addEventListener('click', function() {
      const key = tab.getAttribute('data-bsel-tab');
      $$('[data-bsel-tab]').forEach(function(t) {
        t.classList.toggle('is-on', t === tab);
      });
      $$('[data-bsel-pane]').forEach(function(p) {
        p.classList.toggle('is-on', p.getAttribute('data-bsel-pane') === key);
      });
    });
  });

  $$('[data-bsel-input]').forEach(function(input) {
    input.addEventListener('input', function() {
      const key = input.dataset.bselInput;
      state[key] = input.value;
      render();
    });
  });

  $$('.bsel-cfg__sw[data-color]').forEach(function(sw) {
    sw.addEventListener('click', function() {
      const group = sw.closest('[data-swatches]');
      const key = group.dataset.swatches;
      state[key] = sw.dataset.color;
      render();
    });
  });

  $$('[data-color-input]').forEach(function(input) {
    input.addEventListener('input', function() {
      const key = input.dataset.colorInput;
      let val = input.value.trim();
      if (!val.startsWith('#')) val = '#' + val;
      if (/^#[0-9A-Fa-f]{6}$/.test(val) || /^#[0-9A-Fa-f]{3}$/.test(val)) {
        state[key] = val;
        render();
      }
    });
  });

  $$('[data-slider]').forEach(function(slider) {
    const key = slider.dataset.slider;
    const min = parseInt(slider.dataset.min);
    const max = parseInt(slider.dataset.max);
    const fill = slider.querySelector('.bsel-cfg__slider-fill');
    const knob = slider.querySelector('.bsel-cfg__slider-knob');
    const valEl = root.querySelector('[data-slider-val="' + key + '"]');

    function setFromValue(val) {
      val = Math.max(min, Math.min(max, val));
      val = Math.round(val);
      state[key] = val;
      const pct = ((val - min) / (max - min)) * 100;
      fill.style.width = pct + '%';
      knob.style.left = pct + '%';
      if (valEl) valEl.value = val;
      render();
    }

    function setFromX(clientX) {
      const rect = slider.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      const raw = min + pct * (max - min);
      setFromValue(raw);
    }

    let dragging = false;
    slider.addEventListener('mousedown', function(e) {
      dragging = true;
      setFromX(e.clientX);
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) { if (dragging) setFromX(e.clientX); });
    document.addEventListener('mouseup', function() { dragging = false; });
    slider.addEventListener('touchstart', function(e) {
      dragging = true;
      setFromX(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchmove', function(e) {
      if (dragging) setFromX(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchend', function() { dragging = false; });
  });

  $$('[data-bsel-bundle] .bsel-cfg__pc-option').forEach(function(o) {
    o.addEventListener('click', function() {
      $$('[data-bsel-bundle] .bsel-cfg__pc-option').forEach(function(x) {
        x.classList.remove('is-on');
      });
      o.classList.add('is-on');
      render();
    });
  });

  $$('[data-bsel-sub] .bsel-cfg__sub-option').forEach(function(o) {
    o.addEventListener('click', function() {
      $$('[data-bsel-sub] .bsel-cfg__sub-option').forEach(function(x) {
        x.classList.remove('is-on');
      });
      o.classList.add('is-on');
      render();
    });
  });

  const grid = $('#bselCfgGrid');
  const seeLiveBtn = $('#bselCfgSeeLive');
  if (seeLiveBtn && grid) {
    seeLiveBtn.addEventListener('click', function() {
      const isPreview = grid.classList.toggle('is-preview');
      seeLiveBtn.classList.toggle('is-back', isPreview);
      if (isPreview) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  render();
})();

(function() {
  var sections = document.querySelectorAll('.bsel-cfg');
  if (!sections.length) return;

  var headerHideObserver = new IntersectionObserver(function(entries) {
    var anyVisible = entries.some(function(e) { return e.isIntersecting; });
    if (anyVisible) {
      document.body.classList.add('bsel-cfg-section-active');
    } else {
      var stillVisible = false;
      sections.forEach(function(el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.5 && r.bottom > 80) {
          stillVisible = true;
        }
      });
      if (!stillVisible) {
        document.body.classList.remove('bsel-cfg-section-active');
      }
    }
  }, { threshold: 0, rootMargin: '-80px 0px -50% 0px' });

  sections.forEach(function(sec) { headerHideObserver.observe(sec); });
})();